export enum DaysModeEnum {
  DAY = 'DAY',
  WEEK_WORKING_DAYS = 'WEEK_WORKING_DAYS',
  WEEK = 'WEEK',
}

export const MiddleDayMap = {
  [DaysModeEnum.DAY]: 0,
  [DaysModeEnum.WEEK]: 3,
  [DaysModeEnum.WEEK_WORKING_DAYS]: 2
};

export const PeriodsOffsetMap = {
  [DaysModeEnum.DAY]: 1,
  [DaysModeEnum.WEEK]: 7,
  [DaysModeEnum.WEEK_WORKING_DAYS]: 5
}